import React, { Component } from 'react';
import { PATH } from '../../../../../constants';
import * as SoundManager from '../../../../../utils/SoundManager';
import './MuteSwitch.css';

class MuteSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      muted: true,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({
      muted: SoundManager.muteSwitch(),
    });
  }

  render() {
    const { muted } = this.state;
    return (
      <button
        id="mute-switch"
        type="button"
        className={muted ? 'muted' : ''}
        onClick={this.handleClick}
      >
        <img
          className="mute-ico t-0"
          src={`${PATH.IMG}ico/btn-mute-0.png`}
          alt=""
        />
        <img
          className="mute-ico t-1"
          src={`${PATH.IMG}ico/btn-mute-1.png`}
          alt=""
        />
      </button>
    );
  }
}

export default MuteSwitch;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/SideMenu/MuteSwitch/MuteSwitch.js